import styled from 'styled-components';
import Box from '../index';

const Row = styled(Box)`
  display: flex;
  gap: 8px;
  align-items: center;
`;
export default Row;